import { extendTheme } from '@chakra-ui/react';

import { colors } from './colors';
import { fonts, fontWeights } from './fonts';

export const theme = extendTheme({ colors, fonts, fontWeights });
